import { Collection } from "../ports.js";
/**
 * Durable queue of envelopes the phone still has to hand to the mailbox. Survives the app being killed mid-send;
 * retries with backoff; the mailbox dedupes by envelope id so a retry never doubles a message.
 */
export class Outbox {
    storage;
    constructor(storage) {
        this.storage = storage;
    }
    async enqueue(envelope, now) {
        await this.storage.put(Collection.outbox, envelope.id, {
            envelope,
            attempts: 0,
            next_attempt_at: now.toISOString(),
        });
    }
    async due(now) {
        const all = await this.storage.list(Collection.outbox);
        return all
            .filter((p) => Date.parse(p.next_attempt_at) <= now.getTime())
            .sort((a, b) => a.envelope.id.localeCompare(b.envelope.id));
    }
    async sent(id) {
        await this.storage.delete(Collection.outbox, id);
    }
    /** 2s, 4s, 8s … capped at 10 minutes. */
    async failed(id, now) {
        const p = await this.storage.get(Collection.outbox, id);
        if (!p)
            return;
        const attempts = p.attempts + 1;
        const delayMs = Math.min(2 ** attempts * 1000, 10 * 60 * 1000);
        await this.storage.put(Collection.outbox, id, {
            ...p,
            attempts,
            next_attempt_at: new Date(now.getTime() + delayMs).toISOString(),
        });
    }
    /** Per (engagement, recipient) sequence numbers, so receivers can order and detect gaps. */
    async nextSeq(engagement, to) {
        const key = `${engagement}|${to}`;
        const cur = (await this.storage.get(Collection.outboxSeq, key))?.seq ?? -1;
        await this.storage.put(Collection.outboxSeq, key, { seq: cur + 1 });
        return cur + 1;
    }
}
//# sourceMappingURL=outbox.js.map